import React from 'react';
import { Check } from 'lucide-react';
import { cn } from '../lib/cn';

/**
 * Checkbox — Casilla custom con animación.
 *
 * Usa <input type="checkbox"> nativo invisible para accesibilidad.
 *
 * Uso:
 *   <Checkbox checked={true} onChange={(e) => ...} />
 *   <Checkbox checked={x} disabled />
 */
export const Checkbox = React.forwardRef(({
    checked = false,
    disabled = false,
    className,
    onChange,
    ...props
}, ref) => (
    <label className={cn(
        'inline-flex items-center justify-center shrink-0 cursor-pointer',
        disabled && 'cursor-not-allowed opacity-50',
        className
    )}>
        <input
            ref={ref}
            type="checkbox"
            checked={checked}
            disabled={disabled}
            onChange={onChange}
            className="sr-only peer"
            {...props}
        />
        <span className={cn(
            'w-4 h-4 rounded border-[1.5px] flex items-center justify-center transition-all',
            'peer-focus-visible:ring-2 peer-focus-visible:ring-[hsl(var(--ring))]',
            checked
                ? 'bg-[hsl(var(--brand-light))] border-[hsl(var(--brand-light))]'
                : 'bg-white border-slate-300',
            !disabled && !checked && 'hover:border-slate-400',
        )}>
            {checked && <Check className="size-3 text-white" strokeWidth={3} />}
        </span>
    </label>
));

Checkbox.displayName = 'Checkbox';
